import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

interface FileResponse {
  file: File;
  base64: string;
}

@Directive({
  selector: '[singleFileButton]', // eslint-disable-line @angular-eslint/directive-selector
})
export class SingleFileButtonDirective implements OnInit, OnDestroy {
  private loading = false;
  private input!: HTMLInputElement;
  private inputChangeListener!: Function; // eslint-disable-line @typescript-eslint/ban-types
  @Output() fileSelected = new EventEmitter<FileResponse>();

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.input = this.renderer.createElement('input');
    this.renderer.setAttribute(this.input, 'type', 'file');
    // this.renderer.setAttribute(this.input, 'accept', 'image/png, image/jpg, image/jpeg');
    this.renderer.setAttribute(this.input, 'accept', '');
    this.renderer.addClass(this.input, 'd-none');
    this.renderer.appendChild(this.el.nativeElement, this.input);

    this.inputChangeListener = this.renderer.listen(this.input, 'change', () => {
      this.onSelect();
    });
  }

  @HostListener('click')
  onClick(): void {
    if (!this.loading) {
      this.input.click();
    }
  }

  onSelect(): void {
    const files = this.input.files;

    if (files?.length) {
      this.setLoading(true);

      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          this.fileSelected.emit({
            file: files.item(0) as File,
            base64: reader.result as string,
          });
          this.setLoading(false);
        },
        false,
      );

      reader.addEventListener(
        'error',
        () => {
          this.setLoading(false);
        },
        false,
      );

      reader.readAsDataURL(files.item(0) as File);
    }
  }

  private setLoading(loading: boolean): void {
    this.loading = loading;

    loading
      ? this.renderer.addClass(this.el.nativeElement, 'loading')
      : this.renderer.removeClass(this.el.nativeElement, 'loading');
  }

  ngOnDestroy(): void {
    this.inputChangeListener();
    this.renderer.removeChild(this.el.nativeElement, this.input);
  }
}
